<template>
  <div class="mb-6">
    <v-divider/>
    <v-btn :disabled="!disabled" color="green" outlined class="mb-5" @click="appendChild" left>Реестр +</v-btn>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
        <tr>
          <th v-for="key of keys">{{ key | upper }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item,index) of items" :key="index">
          <td>{{ index + 1 }}</td>
          <td>
            <v-text-field :disabled="!disabled" :rules="[required]" v-model="item.RailwayCarriage" class="mt-6" outlined
                          dense/>
          </td>
          <td>
            <v-text-field :disabled="!disabled" :rules="[required]" v-model="item.ShipmentNumber" class="mt-6" outlined
                          dense/>
          </td>
          <td>
            <v-text-field type="number" :disabled="!disabled" @input="$emit('calculate',items)"
                          v-model="item.WeightTon" class="mt-6"
                          :rules="[number]"
                          outlined dense
            />
          </td>
          <td>
            <oil-date-picker
                             itemKey="DepartureDate"
                             class='mt-6'
                             :item="item"
                             :vInput="{isEdit: disabled}"
                             :keys="dateKeys"
                             :attr="dateKeys.attrs"
            />
          </td>
          <td>
            <v-btn :disabled="!disabled" @click="remove(index)" color="red" icon>
              <v-icon color="red">mdi-delete</v-icon>
            </v-btn>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider/>
  </div>

</template>

<script>
export default {
  props: {
    items: Array,
    disabled: Boolean,
  },
  components: {
    OilDatePicker: () => import('@/components/helper/form/oil.date.picker')
  },
  data() {
    return {
      keys: [
        '#', 'вагон', 'номер отправки', 'вес (тонна)', 'Дата отправки', 'Удалить'
      ],
      dateKeys: {
        attrs: {
          class: 'mt-6',
          readonly: false,
          outlined: true,
          dense: true,
          label: ''
        }
      },
      input: {isEdit: this.disabled},
      required: (value) => !!value || 'Это поля не может быть пустым',
      number: (value) => isNaN(parseFloat(value)) ? 'Можно вести только числа' : true
    }
  },
  methods: {
    appendChild() {
      this.items.push({
        RailwayCarriage: '',
        ShipmentNumber: '',
        WeightTon: 0,
        DepartureDate: ''
      })
    },
    remove(index) {
      this.items.splice(index, 1)
      this.$emit('calculate', this.items)
    }
  },
  filters: {
    upper: (value) => value.toUpperCase()
  }
}
</script>